import { Component, OnInit } from '@angular/core';
import { DataService } from '../../providers/data.service';
import { ActivatedRoute } from "@angular/router";
import {catchError} from "rxjs/operators";
// import {ConfirmationService} from "primeng/api";

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit {
  now: string = new Date().toISOString();
  loading: boolean;
  new_order_count: number;
  stat_name: string;
  stats_data: any;
  top_sales: any;
  chart_options: any;
  chart_type: string = 'horizontalBar';
  chart_types: any  = {
    sales_by_sku: 'horizontalBar',
    sales_by_month: 'bar',
    sales_by_date: 'bar'
  };

  constructor(public dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if(!!params['stat']) this.stat_name = params.stat;
      // this.getStats();
      this.getOrderCounts();
    });
  }

  _prepare_sales_by_sku(){
      let chart_data = {
        labels: [],
        datasets: [
          {label: 'TOP 20 stuks per SKU', data: []},
          {label: 'TOP 20 omzet (100 €) per SKU', data: []}
          ]
      };

      this.stats_data = this.dataService.stats_data[this.stat_name];
      // this.stats_data.sort((a,b) =>{return b['sum Subtotaal'] - a['sum Subtotaal']});
      this.stats_data.sort((a,b) =>{return b['sum Aantal'] - a['sum Aantal']});

      for( let row of this.stats_data.splice(1,20) ){
        chart_data.labels.push(row['SKU'].toString());
        chart_data.datasets[0].data.push(row['sum Aantal']);
        chart_data.datasets[1].data.push(row['sum Subtotaal'] / 100.0);
      }
      this.chart_type = this.chart_types[this.stat_name];
      this.top_sales = chart_data;
  }

  _prepare_sales_by_month() {
      let chart_data = {
        labels: [],
        datasets: [
          {label: 'omzet zondag',    data: [], backgroundColor: '', borderColor: ''},
          {label: 'omzet maandag',   data: [], backgroundColor: '', borderColor: ''},
          {label: 'omzet dinsdag',   data: [], backgroundColor: '', borderColor: ''},
          {label: 'omzet woensdag',  data: [], backgroundColor: '', borderColor: ''},
          {label: 'omzet donderdag', data: [], backgroundColor: '', borderColor: ''},
          {label: 'omzet vrijdag',   data: [], backgroundColor: '', borderColor: ''},
          {label: 'omzet zaterdag',  data: [], backgroundColor: '', borderColor: ''},
          ]
      };

      this.stats_data = this.dataService.stats_data[this.stat_name];

      this.stats_data.sort((a,b) =>{
        let va = a['year(Besteldatum)'] * 100 + a['sum(month(Besteldatum)1())'];
        let vb = b['year(Besteldatum)'] * 100 + b['sum(month(Besteldatum)1())'];
        return  va - vb;
      });

      for( let row of this.stats_data ){
        let key = (row['year(Besteldatum)'] * 100 + row['sum(month(Besteldatum)1())']).toString();

        chart_data.labels.push(key.slice(0,4) + " - " + key.slice(4,6));

        const daynumbers = '1,2,3,4,5,6,7'.split(',');
        for(let d in daynumbers) {
          let k = daynumbers[d];
          // chart_data.datasets[d].data.push(row[k + ' sum Aantal']);
          chart_data.datasets[d].data.push(row[k + ' sum Subtotaal'] / 100.0);
          chart_data.datasets[d].backgroundColor = 'rgb(128, 128,' + (32 * Number(d)) + ')';
          chart_data.datasets[d].borderColor = 'rgb(100, 100,' +  (32 * Number(d)) + ')';
        }
      }
      this.chart_options = {
        scales: {
            xAxes: [{
                stacked: true
            }],
            yAxes: [{
                stacked: true
            }]
        }
      };
      this.chart_type = this.chart_types[this.stat_name];
      this.top_sales = chart_data;
  }

  _prepare_sales_by_date(){

  }

  getOrderCounts() {
    this.loading = true;
    this.dataService.getOrders('new', true).subscribe(result =>{
        this.loading = false;
        this.new_order_count = result.length;
      },
      (err) => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  getStats() {
    this.loading = true;
    let stat_path = 'stats';
    if( !!this.stat_name ) stat_path += '/' + this.stat_name;
    this.dataService.get(stat_path, true).subscribe(
        (result: any) => {
          this.loading = false;
          if(!this.stat_name) {
            this.dataService.stats = result;
          } else {
            this.dataService.stats_data[this.stat_name] = result;
            // call the prepare method of the given stat
            this['_prepare_'+this.stat_name]();
          }
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/stats/stats.component.ts